export const USERS = "/auth/profiles"
export const USER = "/auth/profile/:param"
export const REGENRATE_PASSWORD = "/auth/profiles/:param/generate-password"
